exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.x-button[data-v-a0ea32c4] {\r\n  color: red;\r\n  font-size: 25px;\n}\n.success-label[data-v-a0ea32c4] {\r\n  word-break: break-all;\n}\n.mt-10[data-v-a0ea32c4] {\r\n  margin-top: 10px !important;\n}\r\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/views/PrescriberCrosswalk.vue"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,gBAAgB;CACjB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,4BAA4B;CAC7B","file":"PrescriberCrosswalk.vue","sourcesContent":["\n.x-button[data-v-a0ea32c4] {\r\n  color: red;\r\n  font-size: 25px;\n}\n.success-label[data-v-a0ea32c4] {\r\n  word-break: break-all;\n}\n.mt-10[data-v-a0ea32c4] {\r\n  margin-top: 10px !important;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a0ea32c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/PrescriberCrosswalk.vue
// module id = EB0a
// module chunks = 1